import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { ShowTableDaftarUbahHutangDendaFidusia } from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { SearchBar, Loader } from "../../../components";
import { Colors } from "../../../constants/styles";
import { Form } from "react-bootstrap";
import {
  Box,
  Typography,
  Divider,
  Pagination,
  Button,
  Chip,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilDaftarUbahHutangDendaFidusia = () => {
  const { user, dispatch } = useContext(AuthContext);
  const screenSize = useScreenWidth();
  let navigate = useNavigate();
  const [isFetchError, setIsFetchError] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [
    hutangDendaFidusiasDataPagination,
    setHutangDendaFidusiasDataPagination,
  ] = useState([]);

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    getAngsuranFidusiasPagination();
  }, [page, searchTerm]);

  const getAngsuranFidusiasPagination = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${tempUrl}/ubahHutangDendaFidusiasPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );
      setHutangDendaFidusiasDataPagination(
        response.data.ubahHutangDendaFidusias
      );
      setPage(response.data.page);
      setPages(response.data.totalPage);
      setRows(response.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Box>
      <Typography color="#757575">Fidusia</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Daftar Ubah Hutang Denda
      </Typography>
      <Box sx={buttonModifierContainer}>
        <Button
          variant="contained"
          color="success"
          sx={{ bgcolor: "success.light", textTransform: "none" }}
          startIcon={<AddCircleOutlineIcon />}
          size="small"
          onClick={() => {
            navigate(`/daftarUbahHutangDendaFidusia/tambahUbahHutangDendaFidusia`);
          }}
        >
          Ubah Hutang Denda
        </Button>
      </Box>
      <Divider sx={dividerStyle} />
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Chip
        label="Pelunasan"
        sx={{
          backgroundColor: Colors.red400,
        }}
      />
      <Box sx={tableContainer}>
        <ShowTableDaftarUbahHutangDendaFidusia
          currentPosts={hutangDendaFidusiasDataPagination}
        />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Box>
  );
};

export default TampilDaftarUbahHutangDendaFidusia;

const subTitleText = {
  fontWeight: "900",
};

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const dividerStyle = {
  pt: 4,
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};
